import React from 'react';
import { faRefresh } from '@fortawesome/pro-regular-svg-icons';

import Button from '../../atoms/Button';
import Spinner from '../../atoms/Spinner';
import Text from '../../atoms/Text';
import styles from './FetchError.module.scss';

export interface Props {
  error: {
    message: string;
  };
  refetch: () => void;
}

const FetchError: React.FunctionComponent<Props> = ({ error, refetch }) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error('GraphQL Error: ', error);
  }

  const errorMessage = error?.message ?? '';

  return errorMessage.includes('jwt expired') ? (
    <Spinner />
  ) : (
    <div className={styles['error-container']}>
      <Text className="mb-2" size="sm2" color="gray100">
        Não foi possível carregar os dados.
      </Text>

      <Button variant="outline" icon={faRefresh} onClick={() => refetch()}>
        Recarregar
      </Button>
      {process.env.NODE_ENV !== 'production' && (
        <Text as="p" className="mt-2" size="sm2" color="gray100">
          {error.message}
        </Text>
      )}
    </div>
  );
};
export default FetchError;
